// import { getUsersMinimal } from '../../services/auth';
// import { getVehiclesMinimal } from '../../services/vehicles';
// import { getAllVendorsMinimal } from '../../services/vendors';
import React, {
    createContext, useContext,
    // useEffect, useState 
} from 'react';

const GlobalDataContext = createContext(null);

export const GlobalDataProvider = ({ children }) => {
    // const [users, setUsers] = useState([]);
    // const [vehicles, setVehicles] = useState([]);
    // const [vendors, setVendors] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [accountId, setAccountId] = useState(null);

    // useEffect(() => {
    //     const storedAccountId = localStorage.getItem('accountId');
    //     if (storedAccountId) {
    //         setAccountId(storedAccountId);
    //     }
    // }, []);

    // useEffect(() => {
    //     const fetchGlobalData = async () => {
    //         if (!accountId) return;
    //         setLoading(true);

    //         try {
    //             const [usersRes, vehiclesRes, vendorsRes] = await Promise.all([
    //                 getUsersMinimal(accountId),
    //                 getVehiclesMinimal(accountId),
    //                 getAllVendorsMinimal(accountId),
    //             ]);


    //             if (usersRes.success) setUsers(usersRes.data.data || []);
    //             if (vehiclesRes.success) setVehicles(vehiclesRes.data.data || []);
    //             if (vendorsRes.success) setVendors(vendorsRes.data.data || []);
    //         } catch (err) {
    //             console.error("Failed to fetch global data", err);
    //         }

    //         setLoading(false);
    //     };

    //     fetchGlobalData();
    // }, [accountId]);

    return (
        <GlobalDataContext.Provider
        // value={{ users, vehicles, vendors, loading }}
        >
            {children}
        </GlobalDataContext.Provider>
    );
};

// Custom hook for cleaner access
export const useGlobalData = () => useContext(GlobalDataContext);
